import Route from '@ember/routing/route';
import { inject as service } from '@ember/service';
import { hash } from 'rsvp';

export default class HistoryRoute extends Route 
{
	@service store;
  	model() 
	{
    	return hash({
      	  activators: this.store.findAll('activator')
    	});
  	}
}
